import { INTERACTIVE_CARD } from 'conversations-message-history/common-message-format/constants/attachmentTypes';
import { getAttachmentWithType } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { useAppSelector } from '../../buildStore';
import { ASYNC_STATUS } from '../../constants/asyncStatuses';
import { getInteractiveCardByInstanceId } from '../selectors/getInteractiveCardByInstanceId';
import InteractiveCard from './InteractiveCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const withInteractiveCard = WrappedComponent => {
  var _WrappedComponent$dis;
  const WithInteractiveCard = props => {
    const attachment = getAttachmentWithType(INTERACTIVE_CARD, props.message);
    const cardInstanceId = attachment === null || attachment === void 0 ? void 0 : attachment.get('cardInstanceId');
    const card = useAppSelector(state => cardInstanceId ? getInteractiveCardByInstanceId(state, cardInstanceId) : undefined);
    const cardIsLoading = (card === null || card === void 0 ? void 0 : card.status) === ASYNC_STATUS.STARTED;
    const cardIsRendered = !!(card !== null && card !== void 0 && card.body && card !== null && card !== void 0 && card.locale);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!cardIsLoading && !cardIsRendered && /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props)), cardInstanceId ? /*#__PURE__*/_jsx(InteractiveCard, {
        cardInstanceId: cardInstanceId
      }) : null]
    });
  };
  WithInteractiveCard.displayName = `withInteractiveCard(${(_WrappedComponent$dis = WrappedComponent.displayName) !== null && _WrappedComponent$dis !== void 0 ? _WrappedComponent$dis : 'Component'})`;
  return WithInteractiveCard;
};